import { render, staticRenderFns } from "./AjudaImpressao.vue?vue&type=template&id=70bab7fa&scoped=true"
import script from "./AjudaImpressao.vue?vue&type=script&lang=js"
export * from "./AjudaImpressao.vue?vue&type=script&lang=js"
import style0 from "./AjudaImpressao.vue?vue&type=style&index=0&id=70bab7fa&prod&lang=scss&scoped=true"
import style1 from "./AjudaImpressao.vue?vue&type=style&index=1&id=70bab7fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bab7fa",
  null
  
)

export default component.exports